import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * User tries to upgrade from Plus to Peak and is unable to upgrade their subscription. This event does not include cross-platform errors.
 */
const logUnableToUpgradeSubscription = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('unable to upgrade subscription', {}, callback);
};

export default logUnableToUpgradeSubscription;
